import React from 'react'

import {
  ButtonLink,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  ModalSidebar,
} from '@lightspeed/design-system-react'
import { reactular } from '@vendhq/reactular'
import { VendImage } from '@vend/react-utilities'

/**
 * NoProductsModal
 */
export const NoProductsModal = () => (
  <Modal size="small-with-sidebar">
    <ModalSidebar className="no-products-modal-sidebar">
      <VendImage
        relativeImagePath="/sell/no-products-v3.svg"
        relativeDarkImagePath="/sell/no-products-v3-dark.svg"
        alt="No products"
        className="vd-pt2"
      />
    </ModalSidebar>
    <ModalHeader>Oops, you don't have any products!</ModalHeader>
    <ModalContent>
      You'll need to add some products to your store before you can make a sale
      in Lightspeed Retail.
    </ModalContent>
    <ModalActions>
      <ButtonLink data-track="add-products-no-products-modal" href="/products">
        Add products
      </ButtonLink>
    </ModalActions>
  </Modal>
)

export const wrNoProductsModal = reactular(NoProductsModal)
